import { Stack, Typography } from '@mui/material';
import EnabledFeatureCheck from 'components/EnabledFeatureCheck';
import React from 'react';
import { S4Feature } from 'types/api';
import SSOMappingBarButton from './SSOMappingBarButton';
import SSOTestingBarButton from './SSOTestingBarButton';

const AdvancedSection: React.FC = () => (
	<EnabledFeatureCheck feature={S4Feature.Sso}>
		{/* Title and rows are siblings at 24, matching the Advanced node. */}
		<Stack gap={3}>
			<Typography variant="h3">{intl.tr('home.advancedTitle')}</Typography>
			<SSOMappingBarButton />
			<SSOTestingBarButton />
		</Stack>
	</EnabledFeatureCheck>
);

export default AdvancedSection;
